/**
 * Static keybinds card. Lives in the top-right column directly under
 * the InfoCard so the player always has the control reference visible
 * without having to open a modal.
 *
 * Stateless — no per-frame update, no rebuild. Just renders once on
 * construction. Add new keybinds here as the input map grows; the
 * KeyHandler itself lives in Diorama / Hotbar / main.ts.
 */
export class ControlsCard {
  private root: HTMLDivElement;

  constructor(parent: HTMLElement) {
    this.root = document.createElement('div');
    this.root.className = 'ui-controls-card';
    this.root.innerHTML = `
      <div class="ui-controls-card__title">Controls</div>
      <div class="ui-controls-card__keys">
        <div class="ui-controls-card__key"><kbd>Q</kbd><kbd>E</kbd><span>Rotate camera</span></div>
        <div class="ui-controls-card__key"><kbd>1</kbd>–<kbd>7</kbd><span>Select tool</span></div>
        <div class="ui-controls-card__key"><kbd>K</kbd><span>Skills</span></div>
        <div class="ui-controls-card__key"><kbd>Esc</kbd><span>Close panel</span></div>
        <div class="ui-controls-card__key"><kbd>Wheel</kbd><span>Zoom in / out</span></div>
        <div class="ui-controls-card__key"><kbd>Drag</kbd><span>Pan camera / paint sub-cells</span></div>
      </div>
    `;
    parent.appendChild(this.root);
  }
}
